/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { HedgeRebalanceRecommendationResponseData } from '../models/HedgeRebalanceRecommendationResponseData';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class HedgeRecommendationService {
    public static getApiHedgeRecommendationPosition({
        positionId,
        deltaBandPercent,
        minQuantity,
    }: {
        positionId: number,
        deltaBandPercent?: number,
        minQuantity?: number,
    }): CancelablePromise<HedgeRebalanceRecommendationResponseData> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/hedgerecommendation/position/{positionId}',
            path: {
                'positionId': positionId,
            },
            query: {
                'deltaBandPercent': deltaBandPercent,
                'minQuantity': minQuantity,
            },
        });
    }
}
